import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import currencyFormatter from "currency-formatter";
import moment from "moment";

import OfferListService from "../_services/offer/OfferListService";
import OfferstatusListService from "../_services/offerstatus/OfferstatusListService";
import OfferCopyService from "../_services/offer/OfferCopyService";
import OfferDownloadService from "../_services/offer/OfferDownloadService";
import download from "js-file-download";
import OffermDeleteService from "../_services/offer/OfferDeleteService";
import axios from "axios";

const OfferListComponent = (props) => {

  const {t} = props;
  const [offer, setOffer] = useState([]);
  const [loading, setLoading] = useState(false);
  const dt = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: 1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderOfferList: false})
      OfferListService(JSON.stringify(lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setOffer(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_offer_write') &&
          <>
            <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                    tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                    onClick={() => {
                      window.App.setState({
                        sidebarOfferView: true,
                        modeOfferView: 'edit',
                        props: rowData,
                        activeindexOfferView: 0,
                      })
                    }}/>
            <Button icon="pi pi-clone" className=" p-button-warning p-mr-2"
                    tooltip="Másolás" tooltipOptions={{ position: 'left' }}
                    onClick={() => {
                      if (window.confirm('A másolás megerősítésére van szükség!')) {
                        OfferCopyService(rowData.id)
                          .then(response => {
                            window.App.setState({
                              props: response.data,
                              rerenderOfferList: true,
                              modeOfferView: 'edit',
                              sidebarOfferView: true,
                              activeindexOfferView: 0,
                            })
                          })
                          .catch(error => {
                            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                          })
                      }
                    }}/>
          </>
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip="Megtekintés" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarOfferView: true,
                    props: rowData,
                    activeindexOfferView: 0,
                    modeOfferView: 'show',
                  })
                }}/>
        {rowData && rowData.deleted_at_snapshot ? (
          <Button icon="pi pi-undo" className="p-button-sm p-button-success"
                  tooltip="Visszaállítás" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "/api/v2/project/" + window.App.state.propsProject.id + "/items/" + rowData.id + "/restore",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', t('success_restore'),);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <Button icon="pi pi-trash" className=" p-button-danger"
                  tooltip="Törlés" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      deleteOffer(rowData)
                    }
                  }}
          />
        )}
        <Button icon="pi pi-download" className=" p-button p-ml-2"
                tooltip="Letöltés" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  OfferDownloadService(rowData.id, 'pdf')
                    .then(response => {
                      window.App.toastShow('success', 'Sikeres letöltés!');
                      download(response.data, localStorage.getItem('networkName')
                        + '_'
                        + 'arajanlat'
                        + '_'
                        + rowData.id
                        + '_'
                        + moment.utc(new Date()).local().format('YYYY-MM-DD HH:mm:ss')
                        + '.pdf')
                    })
                    .catch(error => {
                      window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                    })
                }}/>
      </React.Fragment>
    );
  }

  const [statuses, setStatuses] = useState([]);
  const status = (rowData) => {
    if (statuses && statuses[0]) {
      let status = statuses.filter(item => item.id === rowData.status)
      if (status[0] && status[0].name) {
        return status[0].name
      }
    }
  }

  const deleteOffer = (rowData) => {
    OffermDeleteService(rowData.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres törlés!',);
        loadLazyData();
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  useEffect(() => {
    OfferstatusListService()
      .then(response => {
        setStatuses(response.data);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderOfferList === true])

  return (
    <>
      {props && props.view === 'simple' &&
        <>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              {/*{lazyParams && lazyParams.deleted === 1 ? (*/}
              {/*  <Button type="button" icon={"pi pi-eye-slash"}*/}
              {/*          onClick={() => {*/}
              {/*            let _lazyParams = lazyParams*/}
              {/*            delete lazyParams.deleted*/}
              {/*            setLazyParams(_lazyParams)*/}
              {/*            loadLazyData()*/}
              {/*          }}*/}
              {/*          className="p-button-danger"/>*/}
              {/*) : (*/}
              {/*  <Button type="button" icon={"pi pi-eye"}*/}
              {/*          onClick={() => {*/}
              {/*            setLazyParams({*/}
              {/*              ...lazyParams,*/}
              {/*              deleted: 1*/}
              {/*            })*/}
              {/*          }}*/}
              {/*          className="p-button-success"/>*/}
              {/*)}*/}
              {localStorage.getItem('roles').toString().includes('role_offer_write') &&
                <a onClick={() => window.App.setState({sidebarOfferCreate: true})}
                   className={"p-button  p-button-success p-ml-2"}>
                  <i className={"pi pi-plus"}></i>
                  &nbsp;
                  Új árajánlat
                </a>
              }
            </div>
          </div>
        </>
      }
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={offer} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        ref={dt}
      >
        <Column field="name" header="Tárgy" sortable filter filterPlaceholder="Tárgy"
                className={""}></Column>
        <Column field="status" header="Státusz" sortable body={status}
                filter
                filterElement={() => {
                  return (
                    <>
                      {lazyParams && lazyParams.filters && lazyParams.filters.status ? (
                        <Dropdown options={statuses}
                                  id={"statusFilter"}
                                  optionValue={"id"}
                                  optionLabel={"name"}
                                  showClear
                                  emptyMessage={"Még nincs státusz..."}
                                  onChange={(e) => {
                                    dt.current.filter(e.value, 'status', '');
                                  }}
                                  value={lazyParams.filters.status.value}
                        />
                      ) : (
                        <Dropdown options={statuses}
                                  id={"statusFilter"}
                                  optionValue={"id"}
                                  optionLabel={"name"}
                                  showClear
                                  emptyMessage={"Még nincs státusz..."}
                                  onChange={(e) => {
                                    dt.current.filter(e.value, 'status', '');
                                  }}
                        />
                      )}
                    </>
                  )
                }}
        ></Column>
        <Column field="offerNumber" header="Ajánlat szám" sortable filter filterPlaceholder="Ajánlat szám"
                className={"p-text-right p-text-nowrap"}></Column>
        <Column field="partnerName" header="Partner" sortable filter filterPlaceholder="Partner"></Column>
        <Column field="createdAt" header="Létrehozva" sortable className={"p-text-nowrap"} body={(rowData) => {
          if (rowData.createdAt !== null) {
            return (
              <>{moment.utc(rowData.createdAt).local().format('YYYY-MM-DD')}</>
            )
          }
        }}></Column>
        <Column field="validUntil" header="Érvényesség vége" sortable className={"p-text-nowrap"} body={(rowData) => {
          if (rowData.validUntil !== null) {
            return (
              <>{moment.utc(rowData.validUntil).local().format('YYYY-MM-DD')}</>
            )
          }
        }}></Column>
        <Column field="netAmount" header="Nettó összesen" sortable className={"p-text-right p-text-nowrap"}
                alignHeader="right"
                body={(rowData) => {
                  let currency
                  if (rowData.currency === 'HUF') {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: ',',
                      thousand: ' ',
                    }
                  } else {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: '.',
                      thousand: ' ',
                    }
                  }
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.netAmount, {
                          precision: currency.precision,
                          symbol: currency.symbol,
                          decimal: currency.decimal,
                          thousand: currency.thousand,
                        }
                      )}&nbsp;{rowData.currency}
                    </>
                  )
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(OfferListComponent);
